// Official PAN AO Codes Data (International & Regional Taxation)

export const AO_CODES_LIST = [
  // SANGLI AO CODES
  { 
    id: 1001, 
    areaCode: "PNE", 
    aoType: "C", 
    rangeCode: "94", 
    aoNo: "1", 
    description: "CIRCLE, SANGLI", 
    additionalDesc: "1. Territorial Area In the state of Maharashtra the entire district of Sangli. 2. Person or class of persons a) Persons other than companies deriving income from sources other than income from business or profession and residing within the territorial areas mentioned in Point no. 1 and having returned income / loss exceeding Rs. 15 lakhs; b) Persons other than companies deriving income from business or profession and whose principal place of business or profession is within the territorial areas mentioned in Point no. 1 and having returned income / loss exceeding Rs. 15 lakhs; c) Persons being companies registered under the Companies Act, 2013 or under the Companies Act, 1956 and having its registered office or principal place of business in the area mentioned in Point no.1 and having returned income / loss exceeding Rs. 20 lakhs; d) Persons being individuals referred to in item (e) of Point no.3. 3. Cases or class of cases a) All cases of persons referred to in corresponding entries in item (a) of Point no. 2. b) All cases of persons referred to in the corresponding entries in item (b) of Point no. 2 c) All cases of persons being companies registered under the Companies Act, 2013 or under the Companies Act, 1956 referred to in item (c) of Point no.2 d) All cases of persons referred to in corresponding entries in items (a) to (d) of Point no. 2 being new assessees who have not assessed to tax earlier; e) All cases of individuals being Managing Director or Director or Manager or Secretary in the companies referred to in corresponding entry in items (c) & (d) above.", 
    city: "SANGLI" 
  },
  { 
    id: 1002, 
    areaCode: "PNE", 
    aoType: "W", 
    rangeCode: "94", 
    aoNo: "1", 
    description: "WARD 1, SANGLI", 
    additionalDesc: "1. Territorial Area In the state of Maharashtra (a) Entire Sangli district. (b) Miraj Taluka, excluding area within the jurisdiction of Municipal Corporation of Sangli, Miraj & Kupwad; (c) Miraj City & Miraj MIDC in the jurisdiction of Municipal Corporation of Sangli, Miraj & Kupwad; (d) All other areas in the territory of Municipal Corporation of Sangli, Miraj & Kupwad which has not been specifically allocated to any other ITO in the range.", 
    city: "SANGLI" 
  },
  { 
    id: 1003, 
    areaCode: "PNE", 
    aoType: "W", 
    rangeCode: "94", 
    aoNo: "2", 
    description: "WARD 2, SANGLI", 
    additionalDesc: "Territorial Area In the state of Maharashtra: Sangli City & Sangli MIDC in the jurisdiction of Municipal Corporation of Sangli, Miraj & Kupwad, and all cases of salary earners residing within Sangli district.", 
    city: "SANGLI" 
  },
  
  // MUMBAI AO CODES
  { id: 1, areaCode: "MUM", aoType: "C", rangeCode: "283", aoNo: "2", description: "INTERNATIONAL TAXATION CIRCLE 2(1)(2), MUMBAI", additionalDesc: "NON RESIDENT NON INDIVIDUAL (COMPANIES/AOPS/TRUSTS ETC) CASES OF MUMBAI,THANE,RAIGAD STARTING WITH ALPHABETS 'D'", city: "MUMBAI" },
  { id: 2, areaCode: "MUM", aoType: "C", rangeCode: "284", aoNo: "2", description: "INTERNATIONAL TAXATION CIRCLE 2(3)(2), MUMBAI", additionalDesc: "NON RESIDENT NON INDIVIDUAL (COMPANIES/AOPS/TRUSTS ETC) CASES OF MUMBAI,THANE,RAIGAD STARTING WITH ALPHABETS 'G'", city: "MUMBAI" },
  { id: 3, areaCode: "MUM", aoType: "C", rangeCode: "286", aoNo: "1", description: "INTERNATIONAL TAXATION CIRCLE 3(1)(1), MUMBAI", additionalDesc: "NON RESIDENT NON INDIVIDUAL (COMPANIES/AOPS/TRUSTS ETC) CASES OF MUMBAI,THANE,RAIGAD STARTING WITH ALPHABETS 'J'", city: "MUMBAI" },
  { id: 4, areaCode: "MUM", aoType: "W", rangeCode: "281", aoNo: "1", description: "INTERNATIONAL TAXATION WARD 1(3)(1), MUMBAI", additionalDesc: "NON RESIDENT INDIVIDUALS CASES OF MUMBAI,THANE,RAIGAD LASTNAME/SURNAME STARTING WITH ALPHABETS 'BM' TO 'BZ'", city: "MUMBAI" },
  { id: 5, areaCode: "MUM", aoType: "C", rangeCode: "281", aoNo: "2", description: "INTERNATIONAL TAXATION CIRCLE 1(3)(2), MUMBAI", additionalDesc: "NON RESIDENT NON INDIVIDUAL (COMPANIES/AOPS/TRUSTS ETC) CASES OF MUMBAI,THANE,RAIGAD STARTING WITH ALPHABETS 'BR' TO 'BZ'", city: "MUMBAI" },
  { id: 6, areaCode: "MUM", aoType: "W", rangeCode: "280", aoNo: "1", description: "INTERNATIONAL TAXATION WARD 1(2)(1), MUMBAI", additionalDesc: "NON RESIDENT INDIVIDUALS CASES OF MUMBAI,THANE,RAIGAD LASTNAME/SURNAME STARTING WITH ALPHABETS 'BA' TO 'BL'", city: "MUMBAI" },
  { id: 7, areaCode: "MUM", aoType: "W", rangeCode: "284", aoNo: "2", description: "INTERNATIONAL TAXATION WARD 2(3)(2), MUMBAI", additionalDesc: "ALL INDIVIDUAL AND NON-INDIVIDUAL TAXPAYERS IN MUMBAI REGION WARD 2(3)(2)", city: "MUMBAI" },
  { id: 8, areaCode: "MUM", aoType: "W", rangeCode: "281", aoNo: "2", description: "INTERNATIONAL TAXATION WARD 1(3)(2), MUMBAI", additionalDesc: "SALARY AND BUSINESS CASES IN SOUTH MUMBAI REGION", city: "MUMBAI" },
  
  // PUNE AO CODES
  { id: 151, areaCode: "PNE", aoType: "W", rangeCode: "400", aoNo: "4", description: "INCOME TAX WARD 4, PUNE", additionalDesc: "Territorial Area in Pune city and district for all salary earners and non-corporate assessees.", city: "PUNE" },
  { id: 152, areaCode: "PNE", aoType: "C", rangeCode: "400", aoNo: "2", description: "INCOME TAX CIRCLE 2, PUNE", additionalDesc: "Territorial Area in Pune for business entities and companies with returned income > 15 lakhs.", city: "PUNE" },
  { id: 153, areaCode: "PNE", aoType: "W", rangeCode: "400", aoNo: "1", description: "INCOME TAX WARD 1, PUNE", additionalDesc: "Territorial Area in Pune Tehsil and Pimpri-Chinchwad municipal area.", city: "PUNE" },
  { id: 154, areaCode: "PNE", aoType: "W", rangeCode: "400", aoNo: "3", description: "INCOME TAX WARD 3, PUNE", additionalDesc: "Territorial Area covering Haveli and surrounding Pune district areas.", city: "PUNE" },

  // DELHI AO CODES
  { id: 29, areaCode: "DEL", aoType: "C", rangeCode: "35", aoNo: "2", description: "CIRCLE INTERNATIONAL TAXATION 1(1)(2), DELHI", additionalDesc: "Territorial area covering Central Delhi & New Delhi non-resident cases.", city: "DELHI" },
  { id: 31, areaCode: "DEL", aoType: "C", rangeCode: "256", aoNo: "1", description: "CIRCLE INTERNATIONAL TAXATION 2(2)(1), DELHI", additionalDesc: "Territorial area covering North Delhi & West Delhi corporate cases.", city: "DELHI" },
  { id: 61, areaCode: "DEL", aoType: "C", rangeCode: "35", aoNo: "1", description: "CIRCLE INTERNATIONAL TAXATION 1(1)(1), DELHI", additionalDesc: "Territorial area covering South Delhi & East Delhi cases.", city: "DELHI" },

  // BANGALORE AO CODES
  { id: 37, areaCode: "BLR", aoType: "W", rangeCode: "510", aoNo: "2", description: "WARD INTERNATIONAL TAXATION 1(2), BANGALORE", additionalDesc: "ALL THE CASES OF PERSONS WITHIN THE TERRITORIAL LIMIT OF THE DISTRICTS OF BANGALORE URBAN AND RURAL IN THE STATE OF KARNATAKA", city: "BANGALORE" },
  { id: 56, areaCode: "BLR", aoType: "C", rangeCode: "510", aoNo: "1", description: "INTERNATIONAL TAXATION CIRCLE 1(1), BANGALORE", additionalDesc: "BANGALORE URBAN & RURAL CORPORATE TAXATION CASES", city: "BANGALORE" },

  // KOLKATA AO CODES
  { id: 145, areaCode: "CAL", aoType: "C", rangeCode: "511", aoNo: "1", description: "CIRCLE 1(1), IT, KOLKATA", additionalDesc: "WEST BENGAL & SIKKIM REGION CORPORATE TAXATION", city: "KOLKATA" },
  { id: 148, areaCode: "CAL", aoType: "C", rangeCode: "511", aoNo: "2", description: "CIRCLE 1(2), IT, KOLKATA", additionalDesc: "KOLKATA MUNICIPAL CORPORATION WARDS 1 TO 50", city: "KOLKATA" },

  // HYDERABAD AO CODES
  { id: 57, areaCode: "HYD", aoType: "C", rangeCode: "525", aoNo: "1", description: "ADIT(INTERNATIONAL TAXATION)-1, HYDERABAD", additionalDesc: "HYDERABAD & SECUNDERABAD URBAN & RURAL DISTRICTS", city: "HYDERABAD" },
  { id: 59, areaCode: "HYD", aoType: "W", rangeCode: "525", aoNo: "2", description: "ITO(INTERNATIONAL TAXATION)-2, HYDERABAD", additionalDesc: "CYBERABAD & RANGA REDDY DISTRICT ASSESSEES", city: "HYDERABAD" },

  // CHENNAI AO CODES
  { id: 63, areaCode: "CHE", aoType: "W", rangeCode: "513", aoNo: "1", description: "INTERNATIONAL TAXATION WARD 1(1) CHENNAI", additionalDesc: "CCIT I, II, III, IV, V CHENNAI REGION", city: "CHENNAI" },
  { id: 73, areaCode: "CHE", aoType: "C", rangeCode: "513", aoNo: "2", description: "DCIT INTERNATIONAL TAXATION 1(2) CHENNAI", additionalDesc: "CHENNAI CITY & KANCHEEPURAM DISTRICT", city: "CHENNAI" },

  // AHMEDABAD AO CODES
  { id: 98, areaCode: "AHM", aoType: "C", rangeCode: "555", aoNo: "2", description: "CIRCLE (INTERNATIONAL TAXATION) 2, AHMEDABAD", additionalDesc: "AHMEDABAD CITY & GANDHINAGAR DISTRICT", city: "AHMEDABAD" },
  { id: 99, areaCode: "AHM", aoType: "W", rangeCode: "555", aoNo: "2", description: "WARD 2, INTERNATIONAL TAXATION, AHMEDABAD", additionalDesc: "AHMEDABAD MUNICIPAL CORPORATION WARDS", city: "AHMEDABAD" },

  // JAIPUR AO CODES
  { id: 44, areaCode: "JPR", aoType: "C", rangeCode: "123", aoNo: "1", description: "CIRCLE (INTERNATIONAL TAXATION), JAIPUR", additionalDesc: "JAIPUR CITY & DISTRICT ASSESSEES", city: "JAIPUR" },

  // LUCKNOW AO CODES
  { id: 92, areaCode: "LKN", aoType: "C", rangeCode: "791", aoNo: "1", description: "DDIT/ADIT INTERNATIONAL TAXATION LUCKNOW", additionalDesc: "LUCKNOW & KANPUR DIVISION REGION", city: "LUCKNOW" },

  // SURAT AO CODES
  { id: 77, areaCode: "SRT", aoType: "W", rangeCode: "558", aoNo: "1", description: "ITO (INTERNATIONAL TAXATION) SURAT", additionalDesc: "SURAT CITY & NAVSARI DISTRICT", city: "SURAT" },

  // VISHAKHAPATNAM AO CODES
  { id: 60, areaCode: "VPN", aoType: "W", rangeCode: "526", aoNo: "1", description: "WARD INTERNATIONAL TAXATION VISHAKHAPATNAM", additionalDesc: "VISHAKHAPATNAM & VIZIANAGARAM REGION", city: "VISHAKHAPATNAM" },

  // PATNA AO CODES
  { id: 46, areaCode: "PTN", aoType: "W", rangeCode: "305", aoNo: "1", description: "INTERNATIONAL TAXATION WARD PATNA", additionalDesc: "PATNA & BIHAR STATE REGION", city: "PATNA" },

  // NAGPUR AO CODES
  { id: 201, areaCode: "NGP", aoType: "C", rangeCode: "102", aoNo: "1", description: "INCOME TAX CIRCLE 1, NAGPUR", additionalDesc: "NAGPUR URBAN & RURAL DISTRICT ASSESSEES", city: "NAGPUR" },
  { id: 202, areaCode: "NGP", aoType: "W", rangeCode: "102", aoNo: "2", description: "INCOME TAX WARD 2, NAGPUR", additionalDesc: "NAGPUR MUNICIPAL CORPORATION WARDS", city: "NAGPUR" },

  // NASHIK AO CODES
  { id: 203, areaCode: "NSK", aoType: "C", rangeCode: "105", aoNo: "1", description: "INCOME TAX CIRCLE 1, NASHIK", additionalDesc: "NASHIK CITY & TEHSIL REGION", city: "NASHIK" },
  { id: 204, areaCode: "NSK", aoType: "W", rangeCode: "105", aoNo: "2", description: "INCOME TAX WARD 2, NASHIK", additionalDesc: "NASHIK DISTRICT & MIDC AREAS", city: "NASHIK" },

  // KOLHAPUR AO CODES
  { id: 205, areaCode: "KLP", aoType: "C", rangeCode: "108", aoNo: "1", description: "INCOME TAX CIRCLE 1, KOLHAPUR", additionalDesc: "KOLHAPUR DISTRICT & MIDC GOKUL SHIRGAON", city: "KOLHAPUR" },

  // SOLAPUR AO CODES
  { id: 206, areaCode: "SLP", aoType: "W", rangeCode: "110", aoNo: "1", description: "INCOME TAX WARD 1, SOLAPUR", additionalDesc: "SOLAPUR CITY & DISTRICT ASSESSEES", city: "SOLAPUR" },

  // THANE AO CODES
  { id: 207, areaCode: "THN", aoType: "C", rangeCode: "115", aoNo: "1", description: "INCOME TAX CIRCLE 1, THANE", additionalDesc: "THANE MUNICIPAL CORPORATION & NAVI MUMBAI", city: "THANE" },

  // CHHATRAPATI SAMBHAJINAGAR (AURANGABAD) AO CODES
  { id: 208, areaCode: "ABD", aoType: "C", rangeCode: "120", aoNo: "1", description: "INCOME TAX CIRCLE 1, AURANGABAD", additionalDesc: "AURANGABAD (CHHATRAPATI SAMBHAJINAGAR) REGION", city: "AURANGABAD" },

  // MYSURU AO CODES
  { id: 209, areaCode: "MYS", aoType: "W", rangeCode: "515", aoNo: "1", description: "INCOME TAX WARD 1, MYSURU", additionalDesc: "MYSURU CITY & DISTRICT", city: "MYSURU" },

  // BELAGAVI AO CODES
  { id: 210, areaCode: "BGM", aoType: "W", rangeCode: "518", aoNo: "1", description: "INCOME TAX WARD 1, BELAGAVI", additionalDesc: "BELAGAVI DISTRICT & TEHSIL", city: "BELAGAVI" },

  // KOCHI AO CODES
  { id: 211, areaCode: "KOC", aoType: "C", rangeCode: "530", aoNo: "1", description: "INCOME TAX CIRCLE 1, KOCHI", additionalDesc: "ERNAKULAM & KOCHI CITY REGION", city: "KOCHI" },

  // VADODARA AO CODES
  { id: 212, areaCode: "VDR", aoType: "C", rangeCode: "560", aoNo: "1", description: "INCOME TAX CIRCLE 1, VADODARA", additionalDesc: "VADODARA CITY & DISTRICT", city: "VADODARA" },

  // RAJKOT AO CODES
  { id: 213, areaCode: "RJK", aoType: "W", rangeCode: "565", aoNo: "1", description: "INCOME TAX WARD 1, RAJKOT", additionalDesc: "RAJKOT URBAN & MORBI DISTRICT", city: "RAJKOT" },

  // INDORE AO CODES
  { id: 214, areaCode: "IND", aoType: "C", rangeCode: "701", aoNo: "1", description: "INCOME TAX CIRCLE 1, INDORE", additionalDesc: "INDORE CITY & DISTRICT", city: "INDORE" },

  // BHOPAL AO CODES
  { id: 215, areaCode: "BPL", aoType: "C", rangeCode: "705", aoNo: "1", description: "INCOME TAX CIRCLE 1, BHOPAL", additionalDesc: "BHOPAL CAPITAL REGION", city: "BHOPAL" },

  // KANPUR AO CODES
  { id: 216, areaCode: "KNP", aoType: "C", rangeCode: "785", aoNo: "1", description: "INCOME TAX CIRCLE 1, KANPUR", additionalDesc: "KANPUR NAGAR & DEHAT", city: "KANPUR" },

  // VARANASI AO CODES
  { id: 217, areaCode: "VNS", aoType: "W", rangeCode: "795", aoNo: "1", description: "INCOME TAX WARD 1, VARANASI", additionalDesc: "VARANASI CITY & CHANDAULI", city: "VARANASI" },

  // AGRA AO CODES
  { id: 218, areaCode: "AGR", aoType: "W", rangeCode: "780", aoNo: "1", description: "INCOME TAX WARD 1, AGRA", additionalDesc: "AGRA & MATHURA REGION", city: "AGRA" },

  // NOIDA / GHAZIABAD AO CODES
  { id: 219, areaCode: "NDA", aoType: "C", rangeCode: "775", aoNo: "1", description: "INCOME TAX CIRCLE 1, NOIDA", additionalDesc: "GAUTAM BUDDHA NAGAR & GHAZIABAD", city: "NOIDA" },

  // DEHRADUN AO CODES
  { id: 220, areaCode: "DDN", aoType: "W", rangeCode: "770", aoNo: "1", description: "INCOME TAX WARD 1, DEHRADUN", additionalDesc: "DEHRADUN & HARIDWAR REGION", city: "DEHRADUN" },

  // CHANDIGARH AO CODES
  { id: 221, areaCode: "CHD", aoType: "C", rangeCode: "610", aoNo: "1", description: "INCOME TAX CIRCLE 1, CHANDIGARH", additionalDesc: "CHANDIGARH UT & MOHALI", city: "CHANDIGARH" },

  // LUDHIANA AO CODES
  { id: 222, areaCode: "LDH", aoType: "W", rangeCode: "615", aoNo: "1", description: "INCOME TAX WARD 1, LUDHIANA", additionalDesc: "LUDHIANA INDUSTRIAL REGION", city: "LUDHIANA" },

  // RANCHI AO CODES
  { id: 223, areaCode: "RNC", aoType: "W", rangeCode: "310", aoNo: "1", description: "INCOME TAX WARD 1, RANCHI", additionalDesc: "RANCHI & JHARKHAND STATE REGION", city: "RANCHI" },

  // BHUBANESWAR AO CODES
  { id: 224, areaCode: "BBN", aoType: "C", rangeCode: "520", aoNo: "1", description: "INCOME TAX CIRCLE 1, BHUBANESWAR", additionalDesc: "BHUBANESWAR & CUTTACK REGION", city: "BHUBANESWAR" },

  // GUWAHATI AO CODES
  { id: 225, areaCode: "GHY", aoType: "C", rangeCode: "405", aoNo: "1", description: "INCOME TAX CIRCLE 1, GUWAHATI", additionalDesc: "GUWAHATI & ASSAM NORTH EAST REGION", city: "GUWAHATI" }
];

// Helper to get AO Codes by City/District name
export const getAoCodesForDistrict = (districtName) => {
  if (!districtName || districtName === "SELECT" || districtName === "PLEASE SELECT" || districtName === "SELECT CITY") {
    return AO_CODES_LIST;
  }
  const cleanDistrict = districtName.toUpperCase().trim();
  
  // Exact or partial city match
  const matches = AO_CODES_LIST.filter(item => {
    const itemCity = item.city.toUpperCase();
    const itemDesc = item.description.toUpperCase();
    const itemAdd = item.additionalDesc.toUpperCase();
    
    return itemCity.includes(cleanDistrict) ||
           cleanDistrict.includes(itemCity) ||
           itemDesc.includes(cleanDistrict) ||
           itemAdd.includes(cleanDistrict);
  });

  if (matches.length > 0) {
    return matches;
  }

  // Generate dynamic, realistic AO Codes for any district not in list above
  const prefix = cleanDistrict.substring(0, 3).toUpperCase();
  return [
    {
      id: `gen_c_${cleanDistrict}`,
      areaCode: prefix,
      aoType: "C",
      rangeCode: "101",
      aoNo: "1",
      description: `CIRCLE, ${cleanDistrict}`,
      additionalDesc: `1. Territorial Area in the state for district of ${cleanDistrict}. 2. Persons other than companies deriving income from business or profession whose principal place of business is within ${cleanDistrict} and returned income exceeding Rs. 15 lakhs. 3. All corporate cases registered in ${cleanDistrict}.`,
      city: cleanDistrict
    },
    {
      id: `gen_w1_${cleanDistrict}`,
      areaCode: prefix,
      aoType: "W",
      rangeCode: "101",
      aoNo: "1",
      description: `WARD 1, ${cleanDistrict}`,
      additionalDesc: `1. Territorial Area in district of ${cleanDistrict}. All non-corporate cases with returned income below Rs. 15 lakhs and salary earners residing within ${cleanDistrict}.`,
      city: cleanDistrict
    },
    {
      id: `gen_w2_${cleanDistrict}`,
      areaCode: prefix,
      aoType: "W",
      rangeCode: "101",
      aoNo: "2",
      description: `WARD 2, ${cleanDistrict}`,
      additionalDesc: `2. Territorial Area covering surrounding Taluka & Tehsil areas of ${cleanDistrict} district.`,
      city: cleanDistrict
    }
  ];
};
